export default class KibanaFilterModel {
    meta;
    $state;
    constructor(meta, $state = { store: 'appState' }) {
        this.meta = meta;
        this.$state = $state;
    }
}
//# sourceMappingURL=osd-filter-model.js.map